import React from 'react';
import CategoryOnlineReportHeader from './CategoryOnlineReportHeader';
import CategoryOnlineReportContent from './CategoryOnlineReportContent';

const CategoryOnlineReportCEO = () => {
    return (
        <>
            <CategoryOnlineReportHeader />
            <CategoryOnlineReportContent />
        </>
    );
};

export default CategoryOnlineReportCEO;
